import { BusinessObjectBase } from './base';
import type { ProcessInstance } from './process-instance';

export interface ProcessInstanceHistoryData {
  readonly id: string;
  readonly eventType: string;
  readonly data?: any;
  readonly timestamp?: Date;
  readonly processInstanceId: number;
  readonly processInstance?: ProcessInstance;
}

export interface ProcessInstanceHistory extends Readonly<ProcessInstanceHistoryData> {}
export class ProcessInstanceHistory extends BusinessObjectBase {
  static readonly entityName = 'ProcessInstanceHistory' as const;
  static readonly plural = 'process-instance-histories';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<ProcessInstanceHistory[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new ProcessInstanceHistory(data));
  }

  static async findOne(filter?: any): Promise<ProcessInstanceHistory | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new ProcessInstanceHistory(data) : null;
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessInstanceHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new ProcessInstanceHistory(data);
  }

  static async create(
    data: Omit<ProcessInstanceHistoryData, 'id'>,
  ): Promise<ProcessInstanceHistory> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new ProcessInstanceHistory(result);
  }

  static async updateById(
    id: string,
    data: Partial<ProcessInstanceHistoryData>,
  ): Promise<ProcessInstanceHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new ProcessInstanceHistory(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
